export default __webpack_public_path__ + "static/snickering-792bbfbf7f88b3330b6327722d597ed0.svg";